import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 401 is owned by the SDK's notifyUnauthorized → KeycloakGate
      // redirect path. Retrying just delays the redirect and burns the
      // user-visible "Não foi possível carregar…" error states. Other
      // failures retry per react-query's default (up to 3x with backoff).
      retry: (failureCount, error: unknown) => {
        if ((error as { status?: number } | undefined)?.status === 401) {
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});
